module.exports = new __parcel__URL__("login.c6eabe34.html").toString();